module.exports = __webpack_public_path__ + "images/patterns/light/GrooveDiagonal.983768b586cd7471d756.svg";